import React, { useEffect, useState } from 'react';
import { Button, Input, Space, Select } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { addNewSearch } from 'utils/utils';
import { SearchRangePicker } from 'components/atoms';
import moment, { Moment } from 'moment';
import 'components/TableSearchBox/index.scss';
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';

const cx = classNames.bind('./index.scss');
export interface CachSearchBoxProp {}

const CachSearchBox = ({}: CachSearchBoxProp): React.ReactElement => {
   /* ======================================================
   * hooks
   * ====================================================== */
   const navigate = useNavigate();
   const location = useLocation();
 
   /* ======================================================
    * variables
    * ====================================================== */
 
   /* ======================================================
    * states
    * ====================================================== */
   const [searchGubun, setSearchGubun] = useState<string|null>();
   const [searchRange, setSearchRange] = useState<RangeValue<Moment>|null>();
   const [searchDateStart, setSearchDateStart] = useState<string>();
   const [searchDateEnd, setSearchDateEnd] = useState<string>();
   
   /* ======================================================
    * events
    * ====================================================== */
   const onChange = (value) => {
      setSearchGubun(value);
      navigate({
        ...location,
        search: addNewSearch(location.search, { gubun: value, searchDateStart: searchDateStart, searchDateEnd: searchDateEnd, pageNo: 1 }),
      });      
   };
 
   const onClickReset = (e) => {
     setSearchGubun(null);
     setSearchDateStart('');
     setSearchDateEnd('');
     setSearchRange(null);
     navigate(location.pathname);
   };
 
   const onChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
     setSearchRange(date);
 
     const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYYMMDD') : '';
     const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYYMMDD') : '';
 
     setSearchDateStart(searchDateS);
     setSearchDateEnd(searchDateE);
 
     navigate({
       ...location,
       search: addNewSearch(location.search, { gubun: searchGubun, searchDateStart: searchDateS, searchDateEnd: searchDateE, pageNo: 1 }),
     });   
   };
 
   /* ======================================================
    * effects
    * ====================================================== */
   useEffect(() => {
     const historySearch = getQueryString(location.search);
     if (historySearch.gubun) setSearchGubun(historySearch.gubun);
     if (historySearch.searchDateStart && historySearch.searchDateEnd) {
       setSearchDateStart(historySearch.searchDateStart);
       setSearchDateEnd(historySearch.searchDateEnd);
       setSearchRange([moment(historySearch.searchDateStart, "YYYY-MM-DD"), moment(historySearch.searchDateEnd, "YYYY-MM-DD")]);
     } else {
       setSearchRange(null);
     }   
     
   }, [location.search]);
 
   /* ======================================================
    * render items
    * ====================================================== */
   return (
     <div className={cx('tableSearchBoxWrapper')}>
       <Space>   
        <SearchRangePicker value={searchRange} format="YYYY-MM-DD" onChange={onChangePeriod} style={{width:'250px'}} /> 
        <Select 
          style={{width:"100px"}} 
          value={searchGubun}
          placeholder="구분"
          onSelect={onChange}
          options={[
            {
              value: 'A',
              label: '전체',
            },
            {
              value: 'IN',
              label: '입금',
            },
            {
              value: 'OUT',
              label: '차감',
            },      
            {
              value: 'CANCEL',
              label: '취소',
            },                    
          ]}
        />          
         <Button onClick={onClickReset}>
           검색초기화
         </Button>                
       </Space>
     </div>
   );
};

export default CachSearchBox;
